// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"24d9a012","638":"6c8517ec"}[chunkId] + ".chunk.js";
};